export const isNumeric = (value: any): boolean =>
  typeof value === 'number' && !isNaN(value);

export const isComponentVisible = (elementRef, activeAlert): boolean => {
  const componentElement = elementRef.nativeElement;
  const isComponentVisible1 = componentElement.offsetParent !== null;
  const isDocumentHidden = document.hidden;

  return isComponentVisible1 && !isDocumentHidden && !activeAlert;
};
